module.exports = __webpack_public_path__ + "img/banner_yaoqinghaoyou.21e847d8.png";